import React from "react";
import { Deposite } from "../Deposite/Deposite";
import Withdraw from "../Withdraw/Withdraw";

export const Wallet = ({ isHome, user }) => {
  // Safe formatting for currency (adds commas like 1,000.00)
  const formattedBalance = user.balance
    ? Number(user.balance).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : "0.00";

  return (
    <div className="w-full">
      {/* 1. Wallet Card */}
      <div className="relative w-full bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden p-8 transition-transform hover:scale-[1.01] duration-300">
        {/* Decorative Background Mesh (Refined from your original circles) */}
        {/* Top Right Teal Blob */}
        <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#ACFCE3] rounded-full blur-3xl opacity-40 pointer-events-none"></div>
        {/* Bottom Left Primary Blue Blob (assuming blue-100/200 for 'primary') */}
        <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-blue-100 rounded-full blur-3xl opacity-60 pointer-events-none"></div>

        {/* Card Content */}
        <div className="relative z-10 flex flex-col items-center justify-center text-center">
          <span className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-3">
            Total Balance
          </span>

          <div className="flex items-start gap-1">
            <span className="text-2xl font-bold text-gray-400 mt-1">$</span>
            <h3 className="text-5xl font-black text-slate-800 tracking-tight">
              {formattedBalance}
            </h3>
          </div>

          {/* Optional: User Greeting or ID if needed */}
          {/* <p className="text-xs text-blue-500 mt-2 font-medium bg-blue-50 px-3 py-1 rounded-full">
             Active Account
          </p> */}
        </div>
      </div>

      {/* 2. Action Buttons Row */}
      {/* Using Grid ensures both buttons are equal width */}
      <div className="grid grid-cols-2 gap-4 mt-6">
        <div className="w-full">
          <Withdraw fromWallet={true} />
        </div>
        <div className="w-full">
          <Deposite fromWallet={true} />
        </div>
      </div>
    </div>
  );
};
